/**
 *  @returns User's preferred locale based on browser settings
 */

export const getLocale = () => 'en-US'
// Option to select preferred locale should be added under Profile -> preferences, until that US locale should be used
// typeof navigator.languages !== 'undefined' && navigator.languages.length ?
// navigator.languages[0] :
// navigator.language

export const getLocaleDateString = (date: Date | null) =>
  date ? date.toLocaleDateString(getLocale(), { year: 'numeric', month: 'short', day: 'numeric' }) : ''

export const getLocaleFullDateString = (date: Date | null) =>
  date ? date.toLocaleDateString(getLocale(), { year: 'numeric', month: 'long', day: 'numeric' }) : ''

export const getLocaleMonthString = (date: Date | null) =>
  date ? date.toLocaleDateString(getLocale(), { year: 'numeric', month: 'short' }) : ''
